import { TrainingEventSubscriptionCertificateResponseArray } from '../ss-api/responses/training.event.subscription.certificate.response';
import { EmailLogResponseArray } from '../ss-api/responses/email.log.response';

export enum AttendanceStatusTypes {
    Registered = 1,
    AttendedClass = 2,
    Cancelled = 3,
    Rescheduled = 4,
    NoShow = 5
}

export enum SubscriptionMethodTypes {
    Admin = 1,
    Member = 2,
    Phone = 3,
    Email = 4,
    Other = 99
}

export class TrainingEventSubscription {
    ID: number;
    Created: Date;
    Modified: Date;
    SubscriptionMethodType: SubscriptionMethodTypes;
    AttendancestatusType: AttendanceStatusTypes;
    SubscriptionNotes: string;
    CertificateToken: string;
    CertificatesAwarded: TrainingEventSubscriptionCertificateResponseArray;
    CreditsEarned: number;
    LevelScoreEarned: number;
    AlternatePhone: string;
    AlternateEmail: string;
    License_ID: number;
    LicenseKey: string;
    LicenseStatus: string;
    SignupDate: Date;
    Member_ID: number;
    MemberName: string;
    MemberPhone: string;
    MemberEmail: string;
    MemberHasTOSFlag: boolean;
    MemberIsPastDue: boolean;
    MemberOnHold: boolean;
    Original_Product_ID: number;
    Original_ProductName: string;
    Current_Product_ID: number;
    Current_ProductName: string;
    SoftwareVersion: string;


    EmailLogs: EmailLogResponseArray;

    public static FixDates(item: TrainingEventSubscription) {
        item.Created = new Date(item.Created);
        item.Modified = new Date(item.Modified);
        item.SignupDate = new Date(item.SignupDate);
    }

}

export class TrainingEventSubscriptionArray extends Array<TrainingEventSubscription> {

    constructor(...items: TrainingEventSubscription[]) {
        super(...items);
        Object.setPrototypeOf(this, TrainingEventSubscriptionArray.prototype);
    }

    public static FixDates(item: TrainingEventSubscriptionArray) {
        item.forEach(x => TrainingEventSubscription.FixDates(x));
    }


}
